import * as ErrorConstants from '../../../constants/ErrorConstants';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as LoanApplicationActions from '../../../actions/LoanApplicationActions';
import * as UIActions from '../../../actions/UIActions';
import {defaultState} from '../../state';

const insuranceDataStepView = (state = defaultState.creditoReal.ui.insuranceDataStepView, action) => {
    switch (action.type) {
        case LoanApplicationActions.GET_ALL_QUOTATION_INSURANCES_ACTION.name:
        case LoanApplicationActions.CLEAN_LOAN_APPLICATION_DATA_ACTION.name:
            return {
                ...state,
                hasInsuranceError: false
            };
        case WizardMXActions.GOT_API_ERROR_ACTION.name:
            return {
                ...state,
                hasInsuranceError: action.error === ErrorConstants.WSDL_BITUAJ_ERROR
            };
        case UIActions.CLEAN_STATE_ACTION.name:
        case WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN.name:
            return defaultState.creditoReal.ui.insuranceDataStepView;
        default:
            return state;
    }
};

export default insuranceDataStepView;